import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  statusFormControl: {
    minWidth: 280,
    marginRight: 16,
  },
  typeFormControl: {
    width: 100,
  },
}));
